<template>
	<div>
		<div class="raised-box p-box">
			<SimpleForm
					:onSubmit="onSubmit"
					:fields="[
						{
							label : 'Organisation name',
							name : 'name',
							autocomplete : 'company_name',
							autofocus : true,
							required : true,
							required : !org.personal,
						},
						{
							name : 'billing_email',
							type : 'email',
							label : 'Billing email',
							required : true,
						},
					]"
					:model="org"
				/>
		</div>

	</div>
</template>

<script>

	import SimpleForm from '../../components/SimpleForm';

	export default {
		components : {
			SimpleForm,
		},
		props : [
			'org',
		],
		methods: {
			onSubmit(payload){
				return this.$store
						.dispatch('auth/updateOrg',{id:this.org.id,payload})
						.then((org)=>{
							Event.$emit('modal-close');
						})
			}
		}
	}
</script>